import axios from '../axios';

const path = '/api/logout';
export default {
  logout() {
    return axios.get(path);
  },
};
